module.exports = __webpack_public_path__ + "img/arg.06913d0c.png";